export const LOREAL_TYPES = {
  ACNE_IN_FEMALE: 'acneinfemale',
  ACNE_IN_MALE: 'acneinmale',
  ACTINIC_KERATOSIS: 'actinickeratosis',
  ATOPIC_ECZEMA: 'atopiceczema',
  CONTACT_DERMATITIS: 'contactdermatitis',
  PSORIASIS: 'psoriasis',
  SEBORRHEIC_DERMATITIS: 'seborrheicdermatitis',
};
